<template lang="pug">
  div
    v-card(flat color="white")
      //- router-link(to="/")
      v-responsive.pa-2(v-if="item.imageURL !==''")
        v-img(:src="imageSrc" max-height="100px" contain)
      v-card-title
        v-layout(row wrap)
          v-flex.title(xs12) {{item.itemName}}
          v-flex(xs12) ${{item.cost}} TT
      v-card-actions
           
        v-layout(row)     
          v-flex(xs6)
            add-to-cart-btn(:item="itemWithAmount" itemType='item' @inCart="setInCart")
          v-flex(xs6)
            numberInput(@increment="increment()" @decrement="decrement()" :val="amount"  :disabled="inCart")

</template>
<script>
import AddToCartBtn from './AddToCartBtn'
import NumberInput from '@/components/NumberInput'
export default {
  data:()=>({ 
    amount:1,
    showSlider: false,
    inCart: false
  }),
  components:{AddToCartBtn, NumberInput},
  props:['item'],
  computed:{
    imageSrc(){return this.$store.state.baseImageURL +'th'+ this.item.imageURL+"?alt=media"},
    itemWithAmount(){
      let obj = this.item
      obj.amount = this.amount
      obj = JSON.parse(JSON.stringify(obj))
      return obj
    }
  },
    methods:{
    increment(){
      this.amount+=1
    },
    decrement(){
      this.amount-=1
    },
    setInCart(res){
      if (res.item === this.itemWithAmount){
        this.inCart = res.status
        if (res.amount){
          this.amount = res.amount
        }

      }
    }
  }
}
</script>
<style scoped>
  a > div *, a{
    text-decoration: none;
  }
</style>

